import Page from "./components/page/Page";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const WebWorkFlowMain = ({
  isRowClicked,
  setIsRowClicked,
  mode,
  setMode,
}) => {
  const navigate = useNavigate();
  const permissions = JSON.parse(sessionStorage.getItem("permissions")) || {};

  useEffect(() => {
    if (permissions.admin) {
      return;
    }

    const hasWorkflowPermission =
      permissions?.WorkflowCompanion || permissions?.["Code Enhance"];

    if (!hasWorkflowPermission) {
      navigate("/no-access");
    }
  }, [permissions, navigate]);

  return (
    <Page
      isRowClicked={isRowClicked}
      setIsRowClicked={setIsRowClicked}
      mode={mode}
      setMode={setMode}
    />
  );
};

export default WebWorkFlowMain;